import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock, Save, Trash2, X } from "lucide-react";
import { errText, fetchProforma, invoiceProforma, ron, saveProforma } from "@/lib/bf";
import BFProductSearch from "./BFProductSearch";

export default function BFPfEdit({ r, onSaved, onClose }) {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { let live = true; fetchProforma(r.id).then((d) => live && setItems(d.items)).catch(() => live && setItems([])); return () => { live = false; }; }, [r.id]);
  if (!items) return <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă proforma…</p>;
  const total = items.reduce((s, i) => s + i.unit * (i.q || 0), 0);
  const setQ = (k, v) => setItems((l) => l.map((x, j) => (j === k ? { ...x, q: v === "" ? "" : Math.max(1, Math.min(9999, Math.round(+v) || 1)) } : x)));
  const add = (o) => setItems((l) => (l.some((x) => x.name === o.name) ? l.map((x) => (x.name === o.name ? { ...x, q: x.q + 1 } : x)) : [...l, { name: o.name, code: o.code || "", q: 1, unit: o.unit, size: "", list: o.list ?? null }]));
  const save = () => {
    setBusy(true);
    return saveProforma(r.id, items.map((i) => ({ ...i, q: i.q || 1 }))).then((d) => { onSaved({ ...r, total: d.total, pieces: d.pieces, parts: d.parts, edited: true }); toast.success(`Proforma ${r.no} a fost actualizată`); return true; })
      .catch((e) => { toast.error(errText(e, "Nu am putut salva")); return false; }).finally(() => setBusy(false));
  };
  const invoice = async () => {
    if (!window.confirm(`Generezi factura pentru ${r.no}? După asta doar adminul mai poate modifica comanda.`)) return;
    if (!(await save())) return;
    invoiceProforma(r.id).then(() => { onSaved({ ...r, total, locked: true, edited: true }); onClose(); toast.success("Comanda a fost trimisă la facturare"); })
      .catch((e) => toast.error(errText(e, "Nu am putut trimite la facturare")));
  };
  return (
    <div className="bf-pfe" data-testid={`bf-pfe-${r.no}`}>
      <BFProductSearch onAdd={add} />
      <div className="bf-rb-table"><table>
        <thead><tr><th>Buc.</th><th>Produs</th><th>Preț</th><th>Total</th><th /></tr></thead>
        <tbody>{items.map((i, k) => (
          <tr key={`${i.name}-${k}`} data-testid={`bf-pfe-row-${k}`}>
            <td><input type="number" min="1" value={i.q} onChange={(e) => setQ(k, e.target.value)} onBlur={() => i.q === "" && setQ(k, 1)} data-testid={`bf-pfe-q-${k}`} /></td>
            <td>{i.name}{i.code && <small>cod {i.code}</small>}</td>
            <td className="bf-rb-sum">{ron(i.unit)}</td><td className="bf-rb-sum">{ron(i.unit * i.q)}</td>
            <td>{items.length > 1 && <button type="button" onClick={() => setItems((l) => l.filter((_, j) => j !== k))} aria-label="Șterge" data-testid={`bf-pfe-del-${k}`}><Trash2 size={14} /></button>}</td>
          </tr>
        ))}</tbody>
      </table></div>
      <b className="bf-pfe-total" data-testid={`bf-pfe-total-${r.no}`}>Total: {ron(total)}</b>
      <div className="share-actions">
        <button type="button" className="st-btn st-btn--light" onClick={save} disabled={busy} data-testid={`bf-pfe-save-${r.no}`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează modificările</button>
        {!r.locked && <button type="button" className="st-btn st-btn--silver" onClick={invoice} disabled={busy} data-testid={`bf-pfe-invoice-${r.no}`}><Lock size={14} /> Generează factura</button>}
        <button type="button" className="st-btn st-btn--ghost" onClick={onClose} data-testid={`bf-pfe-close-${r.no}`}><X size={14} /> Închide</button>
      </div>
    </div>
  );
}
